<template>
  <div class="flex rounded-md border border-gray-200 px-6 py-4">
    <div class="flex w-full flex-col gap-3">
      <div class="flex w-full justify-between">
        <Headline tag="h5" look="h4">
          {{ headline }}
        </Headline>
      </div>
      <div class="mb-auto">
        <div>{{ store.street }}</div>
        <div>{{ `${store.zip} ${store.city}` }}</div>
        <div class="flex">
          <div class="flex flex-col justify-center">
            <LazyIconFielmannPin class="mr-1 size-4" />
          </div>
          <div class="flex flex-col justify-center">
            {{ store.distance.toFixed(2) }} km
          </div>
        </div>
        <StoreStatus :opening-details="store" />
      </div>
      <div class="mt-2 flex flex-col items-center">
        <FimButton type="primary" class="w-full" :to="detailsUrl">{{
          $t('store_finder.city_page.store_cta_label')
        }}</FimButton>
        <FimButton class="mt-2" type="link-alternative" :to="appointmentUrl">{{
          $t('store_finder.city_page.store_appointment_label')
        }}</FimButton>
        <FimButton
          v-if="store.isRopo"
          no-padding
          type="link-alternative"
          @click="gotoRopoBasket(store)"
        >
          <span>
            {{ $t('ropo.ndl.list_cta') }}
          </span>
        </FimButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Headline from '~/components/ui/headlines/Headline.vue'
import StoreStatus from '~/components/store-finder/StoreStatus.vue'
import type { IStore } from '~/rpcMethods/stores'
import FimButton from '~/components/ui/buttons/FimButton.vue'
import { useAppointments } from '~/composables/useAppointments'
import { useRopoBasketState } from '~/composables/useRopoBasketState'

const props = defineProps({
  store: {
    type: Object as PropType<IStore & { isRopo?: boolean }>,
    required: true,
  },
})

const { $fimLocalePath, $i18n } = useNuxtApp()

const detailsUrl = computed(() => {
  return getStoreUrl(props.store, $fimLocalePath)
})

const { getAppointmentInBranchUrl } = await useAppointments()

const appointmentUrl = computed(() => {
  return getAppointmentInBranchUrl(props.store.recordsetID)
})

const { gotoRopoBasket } = await useRopoBasketState()

const headline = computed(() => getStoreHeadline(props.store, $i18n))
</script>
